// extracted by mini-css-extract-plugin
export var growableInput = "_8s-0";
export var tagContainer = "_8s-2";
export var textInput = "_8s-1";